import { WorkspaceLayout } from '@/components/ui/workspace';
import { useDiscoverySummaryQuery } from '@/lib/api/discovery';
import { DiscoveryDashboard } from './dashboard';
import { DiscoveryGuide } from './guide';

/**
 * Discovery -> Overview (T-0185, Decision 47): the guide until evidence is
 * first confirmed, then the dashboard for good. The API decides which
 * (`mode`); the frame around it is `DiscoveryLayout`.
 */
export function DiscoveryOverview({ engagementId }: { engagementId: string }) {
  const { data: s } = useDiscoverySummaryQuery(engagementId);
  if (!s?.started) return null;
  return (
    <WorkspaceLayout>
      {s.mode === 'guide' ? (
        <DiscoveryGuide engagementId={engagementId} summary={s} />
      ) : (
        <DiscoveryDashboard engagementId={engagementId} summary={s} />
      )}
    </WorkspaceLayout>
  );
}
